module.exports = __webpack_public_path__ + "img/login_oval_right.7fe18002.png";